import { render, staticRenderFns } from "./googlePayTest.vue?vue&type=template&id=90e3ec0c"
import script from "./googlePayTest.vue?vue&type=script&lang=js"
export * from "./googlePayTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports